<template>
  <div >
    <div class="navDiv" id="topheader">
      <div
        style="
          height: 45px;
          background: #2c2d31;
          line-height: 45px;
          color: #e6e6e6;
          font-size: 12px;
        "
      >
        <span style="margin-left: 10px">{{
          $t("LanguageEn.TournamentInfo")
        }}</span>
      </div>
      <div
        style="
          height: 140px;
          background: #212225;
          line-height: 140px;
          color: white;
        "
      >
        <img
          :key="tournamentId"
          :src="tournamentLogo + tournamentId"
          style="
            width: 67px;
            margin-left: 20px;
            margin-right: 20px;
            background: lightgrey;
            border-radius: 8px;
          "
        />
        {{ leagueTable | transliterate(languageCode) }}
        <b-btn
          v-if="isFavorite"
          v-on:click="removeFavorite({ value: tournamentId, type: 'tournament' })"
          style="
            background: none;
            width: 5px;
            height: 5px;
            border: none;
            margin-left: 10px;
          "
        >
          <img
            src="@/assets/orStar.png"
            style="width: 15px; margin-top: -32px; margin-left: -10px"
            alt=""
          />
        </b-btn>
        <b-btn
          v-else
          v-on:click="addToFavorites({ value: tournamentId, type: 'tournament' })"
          style="
            background: none;
            width: 5px;
            height: 5px;
            margin-left: 10px;
            border: none;
          "
        >
          <img
            src="@/assets/favorite.svg"
            style="width: 15px; margin-top: -32px; margin-left: -10px"
            alt=""
          />
        </b-btn>
      </div>
      <nav
        class="navbar navbar-expand navbar-light"
        style="background: #2c2d31; height: 45px"
      >
        <div class="collapse navbar-collapse" id="navbarNav">
          <ul class="navbar-nav pl-0 pr-0">
            <li class="nav-item">
              <router-link
                id="routerLink"
                style="font-weight: 550; color: lightgrey"
                :to="{ name: 'LeaguePageGames', params: { id: tournamentId } }"
              >
                {{ $t("LanguageEn.txtResults") }}</router-link
              >
              <!-- <img style="height: 22px; margin-right: 5px;" src="@/assets/results.png"> -->
            </li>
            <li class="nav-item">
              <router-link
                id="routerLink"
                style="font-weight: 550; color: lightgrey"
                :to="{ name: 'LeaguePage', params: { id: tournamentId } }"
              >
                {{ $t("LanguageEn.txtTable") }}
              </router-link>
              <!-- <img style="height: 22px; margin-right: 5px;" src="@/assets/leagueTable.png"> -->
            </li>
            <li class="nav-item">
              <router-link
                id="routerLink"
                style="font-weight: 550; color: lightgrey"
                :to="{ name: 'Archive', params: { id: tournamentId } }"
              >
                {{ $t("LanguageEn.archive") }}
              </router-link>
              <!-- <img style="height: 22px; margin-right: 5px;" src="@/assets/leagueTable.png"> -->
            </li>
          </ul>
        </div>
      </nav>
      <div style="color: black">
        <router-view :key="$route.path" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import {API_BASE_URL} from "@/repository/repository";

export default {
  name: "LeaguePageNav",
  data() {
    return {
      tournamentId: "",
      tournamentLogo: API_BASE_URL+"/tournament/logo/",
      leagueTable: "",
    };
  },
  watch:{
    "$route"(){
      this.tournamentId = parseInt(this.$route.params.leagueId);
      this.loadTournamentDetails();
    },
    languageCode(){
      this.loadTournamentDetails();
    }
  },
  async mounted() {
    this.tournamentId = parseInt(this.$route.params.leagueId);
    this.loadTournamentDetails();

  },
  methods: {
    ...mapActions(["removeFavorite", "addToFavorites"]),
    loadTournamentDetails(){

      //todo get details from another API's

      fetch(
          API_BASE_URL+"/standings?portalId=" +
          this.portalId +
          "&token=" +
          this.token +
          "&tournamentId=" +
          this.tournamentId
      ).then(res=>res.json())
          .then(data=>{
            if(data.code===200) {
              this.leagueTable = data.standings[0].tournament.name;
            } else {
              //todo beatify
              alert('Wrong reqeust:' +data.code+' '+ data.message);
              location.href = '/';
            }
          });
    }
  },
  computed: {
    ...mapGetters(["favTournaments", "languageCode", "portalId", "token" ]),
    isFavorite(){
      return this.favTournaments.some((fav) => fav.id === this.tournamentId);
    }
  },
};
</script>

<style scoped>
.navDiv {
  width: auto;
  height: auto;
  color: black;
  background: #f9f9f9;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}

.nav-item {
  font-size: small;
}
.nav-link {
  height: 40px;
  color: green !important;
  text-align: center;
}

#routerLink {
  padding-top: 10%;
  display: inline-block;
  text-decoration: none;
  width: 90px !important;
  height: 43px !important;
  color: white;
  text-align: center !important;
}
#routerLink .navbar-nav li > a {
  text-transform: capitalize;
  transition: background-color 0.2s, color 0.2s;
}

#routerLink .navbar-nav li > a:focus {
  color: #f0af46;
}

.router-link-active {
  color: white !important;
  border-bottom: solid 3px #1c5e20;
}
/* Navbar link underline */

#topheader .navbar-nav li > a {
  text-transform: capitalize;
  transition: background-color 0.2s, color 0.2s;
}

#topheader .navbar-nav li > a:focus {
  color: #fff !important;
}

#topheader .navbar-nav li.active > a {
  background-color: #333;
  color: #fff;
}
@media only screen and (max-width: 770px) {
  body {
    background: #212529;
  }
  .navDiv2 {
    width: 100%;
    height: 60px;
    color: white;
    background: #1b1d20;
  }
  .MobileHide {
    display: none;
  }
  #routerLink {
    padding-top: 8px;
    display: inline-block;
    text-decoration: none;
    height: 40px;
    color: lightgray;
    font-weight: 500;
    text-align: center;
  }
}

@media only screen and (min-width: 992px) {
  .MobileShow {
    display: none;
  }
}
</style>
